import { Box, Icon } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { MessageAttachedFile } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import Image from 'components/shared/Image/Image';
import { actions } from 'components/shared/attachmentsPreviewModal/actions/attachmentsPreviewModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import styles from './storyImage.module.scss';

type StoryImageProps = {
  readonly attachment: MessageAttachedFile;
  readonly onError: () => void;
};

export const StoryImage = ({
  attachment: { url, pretty_name },
  onError,
}: StoryImageProps): JSX.Element => {
  const dispatch = useAppDispatch();

  const handlePreview = useCallback(() => {
    dispatch(
      actions.attachmentsPreviewModalOpen({
        fileName: pretty_name,
        url,
      }),
    );
    ampli.conversationAttachedImageIsViewed();
  }, [dispatch, url, pretty_name]);

  return (
    <Box className={styles.root} onClick={handlePreview}>
      <Image
        className={styles.image}
        src={url}
        alt={pretty_name}
        onErrorHandler={onError}
      />

      <Box className={styles.overlay}>
        <Icon name="eye" size={24} color={colors.neutral['000']} />
      </Box>
    </Box>
  );
};
